var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Actions",
    {
      directives: [
        {
          name: "shortkey",
          rawName: "v-shortkey",
          value: _vm.shortKeyConf,
          expression: "shortKeyConf"
        }
      ],
      attrs: { "default-icon": _vm.defaultIcon, "menu-align": "right" },
      nativeOn: {
        shortkey: function($event) {
          return _vm.selectViewFromShortcut($event)
        }
      }
    },
    _vm._l(_vm.views, function(view) {
      return _c(
        "ActionButton",
        {
          key: view.id,
          attrs: { icon: view.icon },
          on: {
            click: function($event) {
              return _vm.selectView(view.id)
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(view.label) + "\n\t")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }